import * as Progress from '@radix-ui/react-progress';
import cn from 'classnames';
import { FC } from 'react';

import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  value: number | null;
  ariaLabel?: string;
  className?: string;
  testID?: string;
  height?: number;
  isRunning?: boolean;
  showLabel?: boolean;
};

export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const {
    value,
    ariaLabel,
    className,
    testID,
    height = 8,
    isRunning = false,
    showLabel = false,
  } = props;

  const percent =
    value === null ? null : Math.round(Math.min(Math.max(value, 0), 100));

  return (
    <div className={cn(styles.container, className)} data-testid={testID}>
      <Progress.Root
        aria-label={ariaLabel}
        className={styles.track}
        style={{ height }}
        value={percent}
      >
        <Progress.Indicator
          className={cn(
            styles.indicator,
            percent !== null && isRunning && styles.running,
          )}
          style={
            percent === null
              ? undefined
              : { transform: `translateX(-${100 - percent}%)` }
          }
        />
      </Progress.Root>

      {showLabel && (
        <span className={cn(styles.label, 'p4')}>
          {percent !== null && `${percent}%`}
        </span>
      )}
    </div>
  );
};
